import axios from "axios";

// The AI "Daily Compass" devotional is served by THIS app's own backend
// (local FastAPI + Mongo), keeping the Google AI key server-side. Everything
// else in the app talks to the external backend via lib/api.js.
const LOCAL_BASE = process.env.REACT_APP_BACKEND_URL;

const localApi = axios.create({ baseURL: `${LOCAL_BASE}/api` });

export default localApi;
